export default __webpack_public_path__ + "static/media/image-deep-earth.f8da6014.jpg";